// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './vuex/store'
import Utils from './utils/utils'
import Global from './utils/Global'
import Axios from 'axios'
// 饿了么配置
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 图片查看
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'


Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(ElementUI)
//Vue.use(Viewer) 默认配置
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.prototype.$utils = Utils

// 配置axios
Vue.prototype.$axios = Axios
Axios.defaults.baseURL = '/'
// Axios.defaults.headers.post['Content-Type'] = 'application/json'

Vue.prototype.$global = Global

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js